import React, { useContext } from "react";
import { themeContext } from "../../../Context";
import "./ErpFeatures.css";

const features = [
  {
    title: "دورة مبيعات مكتملة",
    desc: "من عرض السعر إلى الفاتورة والتحصيل مع ربط مباشر بالمخزون والحسابات.",
  },
  {
    title: "مشتريات ومخزون مترابطان",
    desc: "تتبع أوامر الشراء والاستلام والكميات المتاحة لتقليل التعارض بين الفروع.",
  },
  {
    title: "تقارير تدعم القرار",
    desc: "ملخصات مالية وتشغيلية تساعدك على معرفة الأداء دون انتظار إغلاق يدوي طويل.",
  },
  {
    title: "صلاحيات وأمان للمنشأة",
    desc: "تحكم دقيق بصلاحيات المستخدمين وحماية بيانات الفروع والعمليات الحساسة.",
  },
  {
    title: "أنظمة قطاعية جاهزة",
    desc: "حلول متخصصة للفنادق والمطاعم والخياطة والمحطات والطبية والإنتاج وغيرها حسب نشاطك.",
  },
  {
    title: "امتثال أوضح للفواتير الإلكترونية",
    desc: "الربط مع هيئة الزكاة والضريبة والجمارك ومنصة فاتورة، مع المرحلة الثانية وضريبة القيمة المضافة ورمز QR ومتابعة الإرسال.",
  },
];

const ErpFeatures = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="erp-features" id="erp-features">
      <div className="erp-section-head">
        <h2 style={{ color: darkMode ? "white" : undefined }}>
          ميزات برنامج المحاسبة اليومية
        </h2>
        <p>أدوات واضحة للمبيعات والمشتريات والمخزون والتقارير والقطاعات والفوترة الإلكترونية.</p>
      </div>
      <div className="erp-features-list">
        {features.map((feature, index) => (
          <article className="erp-feature-row" key={feature.title}>
            <span className="erp-feature-num">{String(index + 1).padStart(2, "0")}</span>
            <div>
              <h3 style={{ color: darkMode ? "white" : undefined }}>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ErpFeatures;
